<template>
  <div>
    <material-card>
      <v-toolbar slot="header" color="primary">
        <v-toolbar-title>Npos</v-toolbar-title>
        <v-spacer></v-spacer>
        <search-bar :searchColumns="filteredSearchColumn" @search-query="getCampaignNpos"></search-bar>
        <upload-form
          v-if="uploadEnabled"
          :uploadFieldLabel="'select Npo CSV'"
          :inputName="'input_file'"
          @file-submitted="uploadCsv"
        ></upload-form>
        <v-divider v-if="newNpoEnabled" class="mx-4" inset vertical></v-divider>
        <v-btn
          v-if="newNpoEnabled"
          class="ma-2"
          outlined
          color="white"
          @click.stop="openRightDrawer('npo-form')"
        >New Npo</v-btn>
        <v-divider v-if="associateNpoEnabled" class="mx-4" inset vertical></v-divider>
        <v-btn
          v-if="associateNpoEnabled"
          class="ma-2"
          outlined
          color="white"
          @click.stop="getAvailableNpos"
        >Associate Npo</v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="nposTable.data"
        :options.sync="nposTableOptions"
        :loading="nposTable.loading"
        class="elevation-1"
        :must-sort="true"
        :footer-props="{
        'items-per-page-options': [5, 10, 15, 20, 30, 50]
      }"
        :items-per-page="itemsPerPage"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
        </template>
        <template v-slot:item.name="{ item }">
          <a @click="goToNpo(item)" dark>{{ item.name }}</a>
        </template>
        <template v-slot:item.status_name="{ item }">
          <v-chip :color="getStatusColor(item.status)" dark>{{ item.status_name }}</v-chip>
        </template>
        <template v-slot:item.campaigns="{ item }">
          <div
            class="body-2"
            v-for="campaign in item.campaigns"
            :key="campaign.id"
          >{{campaign.name}}</div>
        </template>
        <template v-slot:item.date_created="{ item }">
          <td>{{item.date_created | formatDateSmall }}</td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="$router.push({ path: 'npos/' + item.id, params: { npoId: item.id } })"
          >mdi-square-edit-outline</v-icon>
          <v-icon small @click="deleteNpo(item.id)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </material-card>

    <v-dialog v-model="nposDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Associate Npo</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-form ref="npoAssociation" v-model="npoAssociationForm.valid">
            <v-select
              v-model="associatedNpo"
              :items="availableNpoList"
              item-value="npo_id"
              item-text="name"
              label="Npo"
              return-object
              :rules="[v => !!v || 'Npo is required']"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary darken-1" outlined @click="nposDialog = false">Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            @click="associateNpo(associatedNpo.npo_id); nposDialog = false"
          >Associate Npo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import apiService from '@/services'
import searchBar from '@/components/common-components/ComponentSearchBar'
import uploadForm from '@/components/npos/ComponentUpload'
import { mapState, mapActions } from 'vuex'
import { tablePaginationMixin } from '@/mixins/tablePaginationMixin'
import { statusColor } from '@/mixins/statusColor'

export default {
  props: {
    uploadEnabled: {
      type: Boolean,
      default: true
    },
    newNpoEnabled: {
      type: Boolean,
      default: true
    },
    associateNpoEnabled: {
      type: Boolean,
      default: true
    },
    upload: {
      type: Boolean,
      default: true
    },
    campaign: {
      type: String,
      required: false
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 15
    },
    headers: {
      type: Array,
      required: false,
      default () {
        return [
          {
            text: 'Npo',
            align: 'left',
            value: 'name',
            sortable: true,
            searchable: true
          },
          {
            text: 'Fiscal Code',
            value: 'fiscal_code',
            sortable: true,
            searchable: true
          },
          {
            text: 'Contact',
            align: 'left',
            value: 'contacts',
            sortable: true,
            searchable: true
          },
          {
            text: 'Intervention area',
            value: 'type',
            sortable: true,
            searchable: true
          },
          {
            text: 'Campaign',
            value: 'campaign',
            sortable: true,
            searchable: true
          },
          {
            text: 'Registration status',
            value: 'registration_status_name',
            sortable: true,
            searchable: true
          },
          {
            text: 'Status',
            value: 'status_name',
            sortable: true,
            searchable: true
          },
          {
            text: 'City',
            value: 'city',
            sortable: true,
            searchable: true
          },
          {
            text: 'Cap',
            value: 'zip_code',
            sortable: true,
            searchable: true
          },
          {
            text: 'Address',
            value: 'address',
            sortable: true,
            searchable: true
          },
          {
            text: 'Actions',
            value: 'action',
            sortable: false
          }
        ]
      }
    }
  },
  components: {
    searchBar,
    uploadForm
  },
  mixins: [tablePaginationMixin, statusColor],
  watch: {
    // nposTableOptions: {
    //   handler () {
    //     this.getCampaignNpos()
    //   },
    //   deep: true
    // },
    rightDrawer: {
      handler () {
        this.getCampaignNpos()
      },
      deep: true
    }
  },

  data () {
    return {
      nposDialog: false,
      associatedNpo: null,
      availableNpoList: [],
      npoAssociationForm: {
        valid: false
      },
      tableExpanded: [],

      file: null,
      dataLoaded: false, // Used to trigger form components re-rendering

      nposTable: {
        data: [],
        total: 0,
        loading: true,
        search: '',
        column_search: ''
      },
      nposTableOptions: {}
    }
  },

  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out unsearchable headers
      return this.headers.filter((item) => item.searchable !== false)
    },

    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),

    loggedIn () {
      return this.auth.loggedIn
    },

    loggedUser () {
      return this.auth.user || null
    },

    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas']),
    ...mapState('layoutevents', ['rightDrawer']),
    statusOptions () {
      // Transform status value into a string
      const statuses = this.statuses.map((i) => {
        i.status_value = i.status_value + ''
        return i
      })
      return statuses
    }
  },

  mounted () {
    this.getCampaignNpos()
  },

  methods: {
    ...mapActions('layoutevents', ['openRightDrawer']),
    // Get Npos associated with the campaign, this will populte the Npos table in campaign detail
    getCampaignNpos (searchParams = {}) {
      this.nposTable.loading = true
      // Hide rigth drawer
      this.rightDrawer = false

      const { sortBy, sortDesc, page, itemsPerPage } = this.nposTableOptions

      let filter = {}
      filter.orderBy = sortBy[0] || null
      filter.orderDesc = sortDesc[0] || null
      filter.page = page
      if (page * itemsPerPage > 500) {
        filter.limit = page * itemsPerPage
      } else {
        filter.limit = 500
      }
      
      filter.campaign_id = this.$route.params.campaignId || null

      filter.search_filter =
        !!searchParams && searchParams.tableSearch !== ''
          ? searchParams.searchColumn
          : ''
      filter.search_value = searchParams.tableSearch || ''

      apiService
        .fetchData('npos', filter)
        .then((response) => {
          //  Take only email of the tech rep
          response.forEach(function (item) { item.contacts = item.contacts.map(function (x) { if (x.is_tech_rep) return x.email }).filter(x => x) })

          this.nposTable.data = response.map(el => {
            return {
              ...el,
              area: el.area.map(e => e.name)
            }
          })
          this.nposTable.total = response[0].total || 0
          this.nposTable.loading = false
        })
        .catch(() => {
          this.nposTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to get Npos'
          })
        })
    },

    uploadCsv (formData) {
      apiService.uploadNpos(formData).then((response) => {
        this.$store.dispatch('alert/showSnackbar', {
          color: 'success',
          text: `CSV Succesfully uploaded`
        })
        this.getCampaignNpos()
      })
    },

    getAvailableNpos () {
      apiService
        .getAvailableNpos()
        .then((response) => {
          this.availableNpoList = response
          this.nposDialog = true
        })
        .catch(
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Unable to load available Npos`
          })
        )
    },
    associateNpo (npoId) {
      const data = {
        npo_id: npoId,
        campaign_id: this.$route.params.campaignId
      }
      apiService.associateNpo(data).then().catch()
    },

    /**
     * Navigation to Npo detail
     */
    goToNpo (item) {
      this.$router.push({ name: 'npodetail', params: { npoId: item.id } })
    },

    /**
     * Npo logical deletion
     */
    deleteNpo (npoId) {
      apiService
        .deleteNpo(npoId)
        .then(response => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Npo succesfully deleted`
          })
          this.getCampaignNpos()
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot delete Npo`
          })
        })
    }
  }
}
</script>
